module.exports = __webpack_public_path__ + "static/Eselhof1-a63d92da813fd330ee54eb88a3e79e04.jpg";